import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th } from "react-super-responsive-table";

//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../components/loading/Loading";
import moment from "moment";
import axios from "axios";
import { Constants } from "../../Constants";

const getBookingsList = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await axios
      .create({ baseURL: Constants.BASE_URL })
      .get(`/bookings-list`, httpOptions);
  } catch (error) {
    throw error;
  }
};

export default function BookingsList() {
  const [loading, setLoading] = useState(false);
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    try {
      setLoading(true);
      let response = await getBookingsList({
        token: "",
      });
      setContacts(response.data.data);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  return (
    <div className="page-content">
      <ToastContainer />
      {loading && <Loading />}
      <Container fluid>
        <Breadcrumbs title="Visitas" breadcrumbItem="Visitas" />

        <Row>
          <Col>
            <div className="table-rep-plugin">
              <div className="table-responsive mb-0">
                <Table className="table table-striped table-bordered">
                  <Thead>
                    <Tr>
                      <Th>Fecha</Th>
                      <Th>Propiedad</Th>
                      <Th>Nombre</Th>
                      <Th>Email</Th>
                      <Th>Celular</Th>
                      <Th>Cedula</Th>
                      <Th>Fecha nacimiento</Th>
                      <Th>Dirección</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {contacts.map((item: any) => (
                      <Tr>
                        <Th>
                          {moment(
                            item.visit_date + " " + item.visit_hour
                          ).format("DD/MM/YYYY HH:mm")}
                          hs
                        </Th>
                        <Th>{item.property?.title}</Th>
                        <Th>{item.user?.name}</Th>
                        <Th>{item.user?.email}</Th>
                        <Th>{item.user?.phone}</Th>
                        <Th>{item.user?.ci}</Th>
                        <Th>
                          {item.user?.birthdate
                            ? moment(item.user?.birthdate).format("DD/MM/YYYY")
                            : ""}
                        </Th>
                        <Th>{item.user?.address}</Th>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
